import { useContext, useState } from "react"
import getServices from "../services/getServices"
import { AuthContext } from "../contexts/auth"

const useColaboradoresState = () => {
    const { signOut } = useContext(AuthContext)
    const [openDialog, setOpenDialog] = useState(false)
    const [pesquisa, setPesquisa] = useState('')
    const [colaboradores, setColaboradores] = useState([])
    const [submit, setSubmit] = useState(false)
    const [detalhesCursoColaborador, setDetalhesCursoColaborador] = useState(null)

    const _getColaboradores = async ()=>{
        if (submit){
            return;
        }
        setSubmit(true)
        let result = await getServices('admin/funcionario/', pesquisa === '' ? null: pesquisa)
        if (result.type === 'success'){
            setColaboradores(result.data)
        }
        else if (result.data?.code === 'token_not_valid'){
            signOut()
        }
        setSubmit(false)
    }

    const _getDetalhesCurso = async (id)=>{
        if (submit){
            return;
        }
        setSubmit(true)
        let result = await getServices(`admin/cursos/colaborador/${id}/`)
        if (result.type === 'success'){
            setDetalhesCursoColaborador(result.data)            
        }
        else if (result.data?.code === 'token_not_valid'){
            signOut()
        }
        setSubmit(false)
    }



    return {
        
        colaboradores: {value: colaboradores, set:_getColaboradores},
        detalhesCursoColaborador: {value: detalhesCursoColaborador, set:_getDetalhesCurso},
        pesquisa: {value: pesquisa, set:setPesquisa},
        openDialog: {value: openDialog, set:setOpenDialog},
        deletar: {value: ()=>{console.log('não implementado')}, set: ()=>{console.log('não implementado')}},
        itemDelete:{value:()=>{console.log('não implementado')}, set:()=>{console.log('não implementado')}},  
        submit: {value: submit, set: _getColaboradores},

    }
}

export default useColaboradoresState